import type { updatePasswordBodyZod } from "@nlc/shared-types";
import type { z } from "zod";

import { useMutation } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useUpdatePasswordMutation() {
  return useMutation({
    mutationFn: async ({
      confirmPassword,
      password,
    }: z.infer<typeof updatePasswordBodyZod>) =>
      await apiClient
        .url("/users/update-password")
        .post({ confirmPassword, password })
        .json(),
    mutationKey: ["update-password"],
  });
}
